import camaignpNo from '../resources/no/campaign.json';
import campaignSe from '../resources/se/campaign.json';
import { CampaignLanguageResources } from '../types/CampaignResources';

export const campaignI18nResources: CampaignLanguageResources = {
  no: { campaign: camaignpNo },
  se: { campaign: campaignSe },
};
